import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import media from '../../../utils/styling/media';

export const StyledLink = styled(({ to, ...props }) => {
  if (to.startsWith('http')) {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return <a {...props} href={to} />;
  }

  return <Link to={to} {...props} />;
})`
  line-height: 0;
  outline: 0;
  padding: 8px;
  margin: -8px;
  border-radius: 3px;

  &:focus-visible, &:focus {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }
`;

export type StyledLogoProps = {
  width: string;
  height: string;
  lgWidth: string;
  lgHeight: string;
};

export const StyledLogo = styled.svg<StyledLogoProps>`
  /* We need to specify the width for IE11 */
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  
  ${media.lg<StyledLogoProps>`
    width: ${({ lgWidth }) => lgWidth};
    height: ${({ lgHeight }) => lgHeight};
  `}
`;
